/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { colors, borderRadius, shadows, typography, transitions } from '../../styles/theme';
import { AppleIcon, GooglePlayColorIcon } from './Icons';

interface StoreBadgesProps {
  appStoreUrl: string;
  playStoreUrl: string;
  align?: 'start' | 'center';
  className?: string;
}

const badgesStyles = css`
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;

  a {
    display: inline-flex;
    align-items: center;
    gap: 0.75rem;
    min-width: 180px;
    padding: 0.625rem 1.25rem;
    background: ${colors.neutral[900]};
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: ${borderRadius.xl};
    text-decoration: none;
    font-weight: ${typography.fontWeight.semibold};
    transition: all ${transitions.fast};
    box-shadow: ${shadows.md};

    &:hover {
      color: white;
      transform: translateY(-2px);
      box-shadow: ${shadows.lg};
      border-color: rgba(255, 255, 255, 0.4);
    }

    svg {
      width: 24px;
      height: 24px;
      flex-shrink: 0;
    }

    .store-text {
      text-align: left;
      line-height: 1.2;

      .small {
        display: block;
        font-size: 0.6875rem;
        color: ${colors.neutral[300]};
        font-weight: ${typography.fontWeight.normal};
      }

      .big {
        display: block;
        font-size: ${typography.fontSize.lg};
      }
    }
  }

  @media (max-width: 479px) {
    a {
      flex: 1 1 100%;
    }
  }
`;

export default function StoreBadges({
  appStoreUrl,
  playStoreUrl,
  align = 'start',
  className,
}: StoreBadgesProps) {
  return (
    <div
      css={[badgesStyles, align === 'center' && css`justify-content: center;`]}
      className={className}
    >
      <a href={appStoreUrl} target="_blank" rel="noopener noreferrer">
        <AppleIcon />
        <span className="store-text">
          <span className="small">App Store'dan</span>
          <span className="big">İndirin</span>
        </span>
      </a>
      <a href={playStoreUrl} target="_blank" rel="noopener noreferrer">
        <GooglePlayColorIcon />
        <span className="store-text">
          <span className="small">Google Play'den</span>
          <span className="big">Edinin</span>
        </span>
      </a>
    </div>
  );
}
